import React from "react";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,

} from "../../../Styling/styledModal/styledModals";
import { BfButtonBlue, BfButtonBlueSecondary } from "../../../Styling/styledForm/styledBlueForm";

export const DifferentDebitorModal = (props) => {
    const { dialogVisible, cancelHandler, acceptHandler } = props.differentDebitorModal;

    const messages = props.differentDebitorModal.messages;

    const handleOkClick = () => {
        acceptHandler();
      };

    const handleCancelClick = () => {
        cancelHandler();
      };
      
    return (

        <StyledModal centered show={true} onHide={handleCancelClick}>

            <StyledModalBody>
                <h4 style={{color: '#ff0f0f'}}><b>{messages.differentDebitorHeader}</b></h4>
                <p style={{whiteSpace: "pre-line"}}>{messages.differentDebitorP}</p>
                <p style={{whiteSpace: "pre-line"}}>{messages.differentDebitorP2}</p>
            </StyledModalBody>
           
            <StyledModalFooter>
                <BfButtonBlue variant="primary" onClick={handleCancelClick}>
                    {messages.cancel}
                </BfButtonBlue>

                <BfButtonBlueSecondary textAsBorder onClick={handleOkClick}>
                    {messages.differentDebitorContinue}
                </BfButtonBlueSecondary>
            </StyledModalFooter>

        </StyledModal>
    );
};